import { useEffect } from 'react';
import { getIsOnProductionEnvironment, UserData } from '@bizzabo/entities';
import { initFullStory, identifyUser } from './fullStoryScripts';

const useFullstory = (user: UserData) => {
    const { id, primaryEmail, firstName, lastName } = user ?? {};

    useEffect(() => {
        const isValidUser = id && primaryEmail;
        const isOnProd = getIsOnProductionEnvironment();

        if (isValidUser && isOnProd) {
            initFullStory();
            identifyUser(id, primaryEmail, firstName, lastName);
        }
    }, [id, primaryEmail, firstName, lastName]);
};

export default useFullstory;
